import React from 'react';
import { Route, Routes } from 'react-router-dom';

import LoginComponent from './LoginComponent';
import { SampleReceivedScanning } from './SampleReceivedScanning';
import { ServiceHeader } from './components';

import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { clearEmailToken, clearAccessToken } from './services/User';

const AppWrapper = () => {

    return (
        <div style={{ background: "rgb(240,242,244", height: "100vh" }}>

            <ServiceHeader
                needsLogOut={true}
                menuItems={[{
                    url: "",
                    title: ""
                    // url: "https://intranet.servitech.com",
                    // title: "Return to Intranet"
                }]}
                title={process.env.REACT_APP_SERVICE_TITLE || `Scan Received Sample`}
            />
            <div className="content-routes">
                <Routes>
                    <Route path="login" element={<LoginComponent />} />
                    <Route exact path="/" element={<SampleReceivedScanning />} />
                </Routes>
            </div>
        </div>
    );
}

export default AppWrapper;
